import React from "react";
import { ItemFilter, FiltersProps } from "../helpers/interfaceHelper";
import ItemFilters from "./ItemFilters";

const changeFilters: ItemFilter[] = [
    {
        property: "group_name",
        name: "Assigned Group",
        disabled: disabledFilters => disabledFilters.includes("group_name"),
        endpoint: "ChangeAssignedGroups"
    },
    {
        property: "status_name",
        name: "Status",
        disabled: disabledFilters => disabledFilters.includes("status_name"),
        endpoint: "ChangeStatuses"
    },
    {
        property: "client_name",
        name: "Companies",
        endpoint: "ChangeClients"
    },
    {
        property: "agent_name",
        name: "Agent",
        disabled: disabledFilters => disabledFilters.includes("agent_name"),
        endpoint: "ChangeAgents"
    },
    {
        property: "type_name",
        name: "Change Type",
        endpoint: "ChangeTypes"
    },
    {
        property: "category",
        name: "Category",
        endpoint: "ChangeCategories"
    },
    {
        property: "sub_category",
        name: "Sub Category",
        endpoint: "ChangeCategories?categoryType=sub"
    },
    {
        property: "item_category",
        name: "Item Category",
        endpoint: "ChangeCategories?categoryType=item"
    }
];

const ChangesFilters: React.FC<FiltersProps> = ({ setFilter, resetFilter, dbViews, view, setView, setDefaultView, search, setSearch, query }) => (
    <ItemFilters
        setFilter={setFilter}
        resetFilter={resetFilter}
        dbViews={dbViews}
        view={view}
        setView={setView}
        setDefaultView={setDefaultView}
        search={search}
        setSearch={setSearch}
        query={query}
        filterList={changeFilters}
    />
);

export default ChangesFilters;
